import { Tooltip } from '@material-ui/core'
import AutocompleteFilter from 'Components/UI/Atoms/Table/Autocomplete'

import DateFilter from '../DatePickerFilter'

const columnsForTable = (data) => {
  const parentStyle = {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    boxSizing: 'border-box',
    display: 'block',
    width: '100%',
    cursor: 'pointer',
  }

  const cellStyle = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
  }

  const emptyColumn = {
    name: ' ',
    label: '',
    display: false,
    filter: false,
    sort: false,
  }

  const array = [emptyColumn, ...data]

  return array.map((item) => ({
    name: item.name,
    label: item.label,
    options: {
      display: item.display,
      filter: item.filter,
      sort: item.sort,
      sortThirdClickReset: true,
      filterList: item.filterList,
      filterType: 'custom',
      customFilterListOptions: {
        render: (v) => `${item.label}: ${v}`,
      },
      customBodyRender: (val) =>
        item.customBodyRender ? (
          <div
            style={{
              position: 'relative',
              height: '20px',
              cursor: 'pointer',
              marginLeft: item.marginLeft || '',
            }}
          >
            <Tooltip title={val}>
              <div style={parentStyle}>
                <div style={cellStyle}>{val}</div>
              </div>
            </Tooltip>
          </div>
        ) : (
          val
        ),
      filterOptions: {
        display: (filterList, onChange, index, column) => {
          // Filtro de tipo fecha
          if (item.filterType === 'date') {
            return (
              <DateFilter
                filterList={filterList}
                onChange={onChange}
                index={index}
                column={column}
              />
            )
          }
          // Filtro de tipo texto/autocompletado
          if (item.filter) {
            return (
              <AutocompleteFilter
                filterList={filterList}
                onChange={onChange}
                index={index}
                column={column}
                label={item.label}
                filterName={item.filterName}
                getOptionLabel={item.getOptionLabel}
                options={item.options}
                style={item.style}
                fullWidth={item.fullWidth}
                defaultOption={item.defaultOption}
                placeholder={item.placeholder}
              />
            )
          }
          return null
        },
      },
    },
  }))
}

export default columnsForTable
